import n from "../_lib/requiredArgs/index.js";
function e(o) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(t) {
    return typeof t;
  } : e = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, e(o);
}
function y(o) {
  return n(1, arguments), o instanceof Date || e(o) === "object" && Object.prototype.toString.call(o) === "[object Date]";
}
export {
  y as default
};
//# sourceMappingURL=index.js.map
